import { CSSObject } from '@chakra-ui/react';

export const GridLayout: CSSObject = {
  rowGap: '0',
};

export const GridItemContent: CSSObject = {
  mt: '1',
  px: '1',
};

export const GridItemFooter: CSSObject = {
  mt: '0',
};

export const GridSubLayout: CSSObject = {
  gridTemplateColumns: ['1fr', null, null, '270px 1fr', '270px 1fr 272px'],
  gridTemplateRows: [
    'auto auto 1fr',
    null,
    null,
    'auto auto 1fr auto',
    'auto 1fr auto',
  ],
  columnGap: ['2.5', null, null, '3'],
  gridTemplateAreas: [
    `
        "betslip"
        "sidenav"
        "content"
        "footer"
      `,
    null,
    null,
    `
        "sidenav betslip"
        "sidenav content"
        "sidenav content"
        "sidenav footer"
      `,

    `
        "sidenav content betslip"
        "sidenav content betslip"
        "sidenav footer betslip"
      `,
  ],

  'body[data-sensitive="true"] &': {
    gridTemplateRows: '',
    gridTemplateColumns: '',
    gridTemplateAreas: '',
  },
};

export const GridHeader: CSSObject = {
  mb: ['0', null, '3'],
  pb: ['0', null, '2'],
  maxW: '100%',
  bg: ['unset', null, 'delta.800'],
  borderBottom: ['unset', null, '2px solid'],
  borderColor: ['unset', null, 'beta.500'],
  boxShadow: ['unset', null, 'lg'],
};

export const GridItemBetslip: CSSObject = {
  position: [null, null, null, null, 'sticky'],
  top: [null, null, null, null, '55px'],
  height: [null, null, null, null, 'calc(100vh - 120px)'],
  bg: 'transparent',
};

export const GridItemToggle: CSSObject = {
  position: [null, null, 'sticky'],
  top: [null, null, null, null, '60px'],
  width: [null, null, '270px'],
};

export const GridItemSideNav: CSSObject = {
  h: [null, null, null, null, 'calc(100vh - 120px)'],
  top: [null, null, null, null, '60px'],
};

export const GridItemResponsibleGambling: CSSObject = {
  mt: '0',
  bottom: '-2',
};
